import React from 'react';
import classNames from 'classnames';
import { ChevronDown } from 'react-feather';
import { Icon } from 'ui';

const Select = ({
  white,
  fullWidth,
  children,
  className,
  selectClass,
  accessible = false,
  featherIcon = false,
  ariaRequired,
  ariaLabel,
  ...props
}) => {
  const selectClassName = classNames({
    NewButton: !accessible,
    AccessibleSelect: accessible,
    'NewButton--white': white,
    [selectClass]: selectClass,
  });

  const containerClassName = classNames('Select', {
    [className]: className,
    'w-fill': fullWidth,
    'Select--withIcon': props.icon,
  });

  return (
    <div className={containerClassName}>
      {props.icon && <Icon className="Select-icon" name={props.icon} />}
      <select
        {...props}
        className={selectClassName}
        aria-required={ariaRequired}
        aria-label={ariaLabel}
      >
        {children}
      </select>

      {featherIcon ? (
        <ChevronDown
          className="Select-arrowsIcon Select-arrowsIcon-featherIcon"
          size={18}
        />
      ) : (
        <Icon
          className="Select-arrowsIcon"
          name="select_arrows"
          aria-label="Select Arrow"
        />
      )}
    </div>
  );
};

Select.defaultProps = {
  white: true,
};

export default Select;
